import CardSequence from './renderers/CardSequence';
import DominoSequence from './renderers/DominoSequence';
import SeriesSequence from './renderers/SeriesSequence';
import MatrixGrid from './renderers/MatrixGrid';
import PlanningGrid from './renderers/PlanningGrid';
import Compass from './renderers/Compass';
import Mastermind from './renderers/Mastermind';
import PathGrid from './renderers/PathGrid';
import Gears from './renderers/Gears';
import VennDiagram from './renderers/VennDiagram';
import DataTable from './renderers/DataTable';
import Chart from './renderers/Chart';
import Figure from './renderers/Figure';
import { Timeline, Pyramid, Steps, Bilan } from './renderers/FicheVisuals';

const RENDERERS = {
    card_sequence: CardSequence,
    domino_sequence: DominoSequence,
    series: SeriesSequence,
    matrix: MatrixGrid,
    planning: PlanningGrid,
    compass: Compass,
    mastermind: Mastermind,
    path_grid: PathGrid,
    gears: Gears,
    venn: VennDiagram,
    data_table: DataTable,
    chart: Chart,
    figure: Figure,
    // Visuels de fiche (notions)
    timeline: Timeline,
    pyramid: Pyramid,
    steps: Steps,
    bilan: Bilan,
};

/**
 * QuestionVisual — dispatches to the right visual renderer.
 * Returns null if no renderer is set (90%+ of questions).
 *
 * Props:
 *   renderer: string | null (e.g. 'card_sequence')
 *   data: object | null (renderer-specific JSON)
 */
export default function QuestionVisual({ renderer, data }) {
    if (!renderer || !data) return null;
    const Renderer = RENDERERS[renderer];
    if (!Renderer) return null;
    return (
        <div className="question-visual">
            <Renderer data={data} />
        </div>
    );
}
